<template>
  <div v-wechat-title="$route.meta.title">
    <common-header @setLocale="getLocale"></common-header>
    <common-nav :locale="locale"></common-nav>
    <common-banner :locale="locale" title="xhpk"></common-banner>
    <common-title :cn="$t('txt.xhpk')" style="margin-top: 50px;"></common-title>
    <div class="certificates">
      <div
        v-for="(event, index) in items"
        :key="index"
        class="certificates-item"
      >
        <img :src="event.url" class="certificates-item-img" />
        <div class="certificates-item-title">{{ event.title }}</div>
      </div>
      <div class="certificates-item small">
        <img :src="items1[0].url" class="certificates-item-img" />
        <div class="certificates-item-title">{{ items1[0].title }}</div>
      </div>
      <div class="certificates-item big">
        <img :src="items1[1].url" class="certificates-item-img" />
        <div class="certificates-item-title">{{ items1[1].title }}</div>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import CommonHeader from "./components/Common/Header";
import CommonNav from "./components/Common/OtherNav";
import CommonFooter from "./components/Common/Footer";
import CommonBanner from "./components/Common/Banner";
import CommonTitle from "./components/Common/Title";
import quality02 from "../assets/images/quality02.jpg";
import quality03 from "../assets/images/quality03.jpg";
import quality04 from "../assets/images/quality04.jpg";
import quality05 from "../assets/images/quality05.jpg";

export default {
  components: {
    UAnimateContainer,
    UAnimate,
    CommonNav,
    CommonHeader,
    CommonFooter,
    CommonTitle,
    CommonBanner
  },
  data() {
    return {
      detail: "",
      id: "",
      items: [
        {
          title: "经验丰富的品质工程师对定制产品进行专业检测",
          url: quality02
        },
        {
          title: "全程记录和测试半成品的质量",
          url: quality03
        }
      ],
      items1: [
        {
          title:
            "生产过程中对半成品（钉芯和钉帽）进行光学筛选，确保每一粒铆钉的质量达到最优",
          url: quality04
        },

        {
          title: "系统地制定品质测试计划，定期随机进行品质抽样检验",
          url: quality05
        }
      ],
      locale: "zh-cn"
    };
  },
  watch: {
    locale(a, b) {
      if (this.locale === "en-us") {
        this.items = [
          {
            title:
              "Experienced quality engineers conduct professional testing on customized products",
            url: quality02
          },
          {
            title:
              "Fully document and test the quality of semi-finished products",
            url: quality03
          }
        ];
        this.items1 = [
          {
            title:
              "During the production process, semi-finished products (nail cores and nail caps) are optically screened to ensure that the quality of each rivet is optimal",
            url: quality04
          },

          {
            title:
              "Systematically formulate quality testing plans and conduct regular random quality sampling inspections",
            url: quality05
          }
        ];
      } else {
        this.items = [
          {
            title: "经验丰富的品质工程师对定制产品进行专业检测",
            url: quality02
          },
          {
            title: "全程记录和测试半成品的质量",
            url: quality03
          }
        ];
        this.items1 = [
          {
            title:
              "生产过程中对半成品（钉芯和钉帽）进行光学筛选，确保每一粒铆钉的质量达到最优",
            url: quality04
          },

          {
            title: "系统地制定品质测试计划，定期随机进行品质抽样检验",
            url: quality05
          }
        ];
      }
    }
  },
  created() {
    let _router = this.$route;
    this.id = _router.params.id;
    this.locale = window.localStorage.getItem("lang")
      ? window.localStorage.getItem("lang")
      : "zh-cn";
  },
  mounted() {
    // this.getData();
  },
  methods: {
    getData() {
      let lang2 = this.locale ? this.locale : "zh-cn";
      this.$axios
        .post(
          "/api/news/detail",
          {
            id: this.id
          },
          {
            headers: {
              token: "application",
              "Accept-Language": lang2
            }
          }
        )
        .then(res => {
          console.log(res);
          if (res.data.errorCode === 0) {
            this.detail = res.data.data.news;
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.certificates {
  width: 90%;
  margin: 0 auto;
  position: relative;
  margin-top: 1rem;
  display: flex;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
  justify-content: space-between;
  &-item {
    width: 45%;
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
    &-img {
      width: 100%;
      height: 100%;
      margin-bottom: 0.2rem;
    }
    &-title {
      font-size: 20px;
      width: 90%;
    }
    &.small {
      width: 30%;
    }
    &.big {
      width: 65%;
    }
  }
}

@media screen and (max-width: 750px) {
  .certificates {
    width: 90% !important;
    margin: 0 auto !important;
    flex-direction: column;
    &-item {
      width: 100% !important;
      margin-bottom: 50px;
      margin-top: 50px !important;
      &-img {
        width: 100%;
      }
      &-title {
        margin-left: 0 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/xhpk.vue